module.exports = __webpack_public_path__ + "img/icon_search.2567372c.svg";